// extracted by mini-css-extract-plugin
export var container = "_3x-0";
export var error = "_3x-9";
export var label = "_3x-5";
export var light = "_3x-6";
export var md = "_3x-3";
export var sm = "_3x-2";
export var thin = "_3x-8";
export var thinBold = "_3x-7";
export var vertical = "_3x-4";
export var xs = "_3x-1";